import { Badge, Icons, Inline, Stack, Text } from "@sembark-travel/ui-base"
import { Link } from "@sembark-travel/ui-router"
import { generatePath } from "../router-utils"
import type { TWalletStats } from "./store"

export function WalletBalanceCard({
	wallet,
	adminTenantId,
}: {
	wallet: TWalletStats | null | undefined
	adminTenantId?: number
}) {
	const isExhausted = wallet?.is_exhausted || false
	const isLow = !isExhausted && (wallet?.is_low || false)

	const heading = (
		<Text fontWeight="semibold">
			<Icons.BankNotes /> Wallet Credits
		</Text>
	)

	if (!wallet && !adminTenantId) {
		return null
	}

	return (
		<Stack gap="2">
			{adminTenantId ? (
				<Link
					to={generatePath("/admin/tenants/:tenantId/subscription-wallet", {
						tenantId: String(adminTenantId),
					})}
				>
					{heading}
				</Link>
			) : (
				heading
			)}
			<Inline gap="2" alignItems="baseline" flexWrap="wrap">
				<Text fontSize="xl" fontWeight="semibold">
					{!wallet ? "..." : wallet.balance.toFixed(2)}
				</Text>
				{isExhausted ? (
					<Badge status="danger" fullRounded>
						Exhausted
					</Badge>
				) : isLow ? (
					<Badge status="warning" fullRounded>
						Low
					</Badge>
				) : null}
			</Inline>
		</Stack>
	)
}
